/**
 * Bármilyen stringből csinál snake-case-t.
 * @example
 * toSnake-case → to_snake_case
 * @param {string} str - A string, amit átalakítunk.
 * @returns {string} Az átalakított szöveg.
 */
module.exports.toSnakeCase = function toSnakeCase (str) {
  if (!str.trim().trimStart()) {
    return ''
  }

  return str
    .trim().trimStart()
    .replace(/([0-9a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .replace(/^[-_]+|[-_]+$/g, '')
    .replace(/\W+/g, '')
    .toLowerCase()
}
